exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".col-6>.form-group>span{width:80% !important}\n", ""]);

